///batchLabel/list

import fetch ,{postFrom}from '../utils/fetch';
export function getList(params) {
    return fetch({
        method: 'GET',
        url: '/batchLabel/list',
        params
    })
}
///batchLabel/getConditionList
export function getConditionList(params) {
    return fetch({
        method: 'GET',
        url: '/batchLabel/getConditionList',
        params
    })
}

export function getYYConditionList(params) {
    return fetch({
        method: 'GET',
        url: '/batchLabel/getYYConditionList',
        params
    })
}

///batchLabel/saveOrEdit
export function saveOrEdit(params) {
    return fetch({
        method: 'POST',
        url: "/batchLabel/saveOrEdit",
        data:params
    })
}
///projectBasics/projectHoseTypeInfo
export function projectHoseTypeInfo(params) {
    return fetch({
        method: 'GET',
        url: '/projectBasics/projectHoseTypeInfo',
        params
    })
}
///batchLabel/stopOrStartLabel 停用or启用
// export function stopOrStartLabel(params) {
//     return fetch({
//         method: 'POST',
//         url: "/batchLabel/stopOrStartLabel",
//         data:params
//     })
// }
export function stopOrStartLabel(params) {
    return postFrom('/batchLabel/stopOrStartLabel',params)
}
///batchLabel/toEditLabel修改标签页面查询
export function toEditLabel(params) {
    return fetch({
        method: 'GET',
        url: '/batchLabel/toEditLabel',
        params
    })
}


// 项目房型联动


export function getHoseTypeInfoListByProId(params) {
    return fetch({
        method: 'POST',
        url: "/projectBasics/getHoseTypeInfoListByProId",
        data:params
    })
}
// 房间 获取标签

export function labelList(params) {
    return fetch({
        method: 'GET',
        url: '/label/list',
        params
    })
}
